import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10b1873a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Principais Recursos do Vue")
], -1))
const _hoisted_2 = { class: "home" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Propriedades")
], -1))
const _hoisted_4 = { class: "routers" }
const _hoisted_5 = { class: "home" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Propriedades")
], -1))
const _hoisted_7 = { class: "routers" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Materiais de estudo do John")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/data"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Data")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/computed"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Computed")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/methods"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Methods")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/watch"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Watch")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/exercicio"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Exercício")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/beforeCreate"
        }, {
          default: _withCtx(() => [
            _createTextVNode("beforeCreate")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/component"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Component")
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/transition"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Transition")
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_8
  ], 64))
}